import React, { useState } from 'react';
import { Package, Star, Leaf, Shield, Eye, Heart, Check } from 'lucide-react';

import frijolesBayosImg from '../../assets/images/productos/PR/FRIJOLES_BAYOS_ANVERSO.png';
import bayosinfo from '../../assets/images/nutrmental/PR/bayos.jpg';
import frijolesNegrosImg from '../../assets/images/productos/PR/FRIJOLES_NEGROS_ANVERSO.png';
import negrosinfo from '../../assets/images/nutrmental/PR/negros.jpg'
import frijolesEnterosImg from '../../assets/images/productos/PR/Enteros.png';
import frijolesPeruanosImg from '../../assets/images/productos/PR/Peruanos.png';
import peruanosinfo from '../../assets/images/nutrmental/PR/peruanos.jpg'

import frijolesPintoImg from '../../assets/images/productos/PR/Pinto.png';

import puebloRicoLogo from '../../assets/images/marcas/LOGOTIPO_PUEBLO RICO_SLOGAN.png';


const PackagedPueblo = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  // Origin state for nutritional image zoom
  const [nutritionalOrigin, setNutritionalOrigin] = useState('50% 50%');
  // Zoom configuration for nutritional images
  const [zoomLevel, setZoomLevel] = useState(1);
  const zoomScale = 2.0; // Change this value to adjust maximum zoom

  const closeModal = () => setSelectedProduct(null);

  const imagenesEmpaquetado = [
    {
      imagen: frijolesBayosImg,
      imagenInfo: bayosinfo,
      titulo: "Frijoles Bayos",
      descripcion: "Color claro característico, uno de los frijoles de mayor consumo por la población mexicana.",
      categoria: "premium",
      detalles: ["430g neto", "Bolsa resellable", "Guardar en lugar fresco y seco"]
    },
    {   
      imagen: frijolesNegrosImg,
      titulo: "Frijoles Negros", 
      descripcion: "frijoles negros de alta calidad, perfectos para tus recetas favoritas.",
      categoria: "premium",
      detalles: ["430g neto", "Bolsa resellable", "Guardar en lugar fresco y seco"]
    },
    {
      imagen: frijolesEnterosImg,
      titulo: "Frijoles Enteros",
      descripcion: "Frijoles enteros cocidos, listos para acompañar cualquier comida mexicana.",
      categoria: "premium",
      detalles: ["430g neto", "Bolsa resellable", "Guardar en lugar fresco y seco"]
    },
    {
      imagen: frijolesPeruanosImg,
      titulo: "Frijoles Peruanos",
      descripcion: "Frijoles peruanos suaves y cremosos, perfectos para guisos y ensaladas.",
      categoria: "premium",
      detalles: ["430g neto", "Bolsa resellable", "Guardar en lugar fresco y seco"]
    },
    {
      imagen: frijolesPintoImg,
      titulo: "Frijoles Pinto",
      descripcion: "Frijoles pinto de sabor suave, ideales para refritos y platillos norteños.",
      categoria: "premium",
      detalles: ["430g neto", "Bolsa resellable", "Guardar en lugar fresco y seco"]
    }
  ];

  const getCategoryColor = (categoria) => {
    const colors = {
      'Orgánicos': 'bg-green-500',
      'Premium': 'bg-purple-500',
      'Gourmet': 'bg-amber-500',
      'Ready-to-Eat': 'bg-blue-500',
      'Shelf-Stable': 'bg-emerald-500',
      'Frozen': 'bg-cyan-500'
    };
    return colors[categoria] || 'bg-gray-500';
  };
  const getCategoryGradient = (categoria) => {
    const gradients = {
      'Orgánicos': 'from-green-500 to-green-600',
      'Premium': 'from-purple-500 to-purple-600',
      'Gourmet': 'from-amber-500 to-amber-600',
      'Ready-to-Eat': 'from-blue-500 to-blue-600',
      'Shelf-Stable': 'from-emerald-500 to-emerald-600',
      'Frozen': 'from-cyan-500 to-cyan-600'
    };
    return gradients[categoria] || 'from-gray-500 to-gray-600';
  };

  const getCategoryIcon = (categoria) => {
    const icons = {
      'Orgánicos': <Leaf className="w-4 h-4" />,
      'Premium': <Star className="w-4 h-4" />,
      'Gourmet': <Shield className="w-4 h-4" />,
      'Ready-to-Eat': <Package className="w-4 h-4" />,
      'Shelf-Stable': <Heart className="w-4 h-4" />,
      'Frozen': <Package className="w-4 h-4" />
    };
    return icons[categoria] || <Package className="w-4 h-4" />;
  };

  // Nutritional image handlers
  const handleNutritionalMove = (e) => {
    const { left, top, width, height } = e.currentTarget.getBoundingClientRect();
    const x = ((e.clientX - left) / width) * 100;
    const y = ((e.clientY - top) / height) * 100;
    setNutritionalOrigin(`${x}% ${y}%`);
  };
  const resetNutritional = () => setNutritionalOrigin('50% 50%');

  return (
    <div className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-6">
            <h2 className="text-4xl lg:text-5xl font-bold text-green-900 leading-tight">
              Productos
            </h2>
            <img 
              src={puebloRicoLogo} 
              alt="Campo Fresco ICF Logo" 
              className="w-32 h-32 md:w-40 md:h-40 lg:w-48 lg:h-48 object-contain drop-shadow-2xl filter brightness-110"
            />
          </div>
        </div>        {/* Grid de productos */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 lg:gap-8">
          {imagenesEmpaquetado.map((empaque, index) => (
            <div 
              key={index}
              className="group relative rounded-2xl overflow-hidden bg-white shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 border border-gray-100 flex flex-col h-full"
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              <div className="aspect-square relative overflow-hidden">
                <img 
                  src={empaque.imagen} 
                  alt={empaque.titulo}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                
                {/* Overlay gradient */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-all duration-300"></div>
                
                {/* Botón de vista rápida */}
                <div className={`absolute top-3 right-3 w-8 h-8 bg-white/90 backdrop-blur-sm rounded-xl flex items-center justify-center transition-all duration-300 ${
                  hoveredIndex === index ? 'opacity-100 scale-100' : 'opacity-0 scale-75'
                }`}>
                  <Eye className="w-4 h-4 text-gray-700" />
                </div>

                {/* Categoría badge */}
                <div className={`absolute top-3 left-3 px-2 py-1 rounded-lg text-white text-xs font-semibold flex items-center gap-1 transition-all duration-300 ${getCategoryColor(empaque.categoria)} ${
                  hoveredIndex === index ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-2'
                }`}>
                  {getCategoryIcon(empaque.categoria)}
                  {empaque.categoria}
                </div>
              </div>

              {/* Contenido */}
              <div className="p-4 flex flex-col flex-grow">
                <div className="flex justify-between items-start mb-2">
                  <h3 className="font-bold text-lg text-gray-900 group-hover:text-green-600 transition-colors duration-300 leading-tight min-h-[3.5rem] flex items-start">
                    {empaque.titulo}
                  </h3>
                  <span className="text-xs font-semibold text-green-600 bg-green-50 px-2 py-1 rounded-md">
                    {empaque.especificaciones}
                  </span>
                </div>
                
                <p className="text-gray-600 text-xs leading-relaxed mb-3 flex-grow min-h-[4rem]">
                  {empaque.descripcion}
                </p>

                {/* Features técnicas */}
                <div className="flex flex-wrap gap-1 mb-3">
                  <span className="px-2 py-1 bg-green-100 text-green-700 text-xs rounded-full">Certificado</span>
                  <span className="px-2 py-1 bg-blue-100 text-blue-700 text-xs rounded-full">FDA</span>
                </div>

                {/* Información técnica */}
                <button
                  onClick={() => hoveredIndex === index && setSelectedProduct(empaque)}
                  className={`w-full py-2 text-center rounded-xl font-semibold text-sm transition-all duration-300 mt-auto focus:outline-none ${
                    hoveredIndex === index 
                      ? 'bg-gradient-to-r from-green-500 to-emerald-600 text-white shadow-md hover:opacity-90'
                      : 'bg-gray-100 text-gray-700 cursor-default'
                  }`}
                >
                  {hoveredIndex === index ? 'Ver Especificaciones' : 'Ver Información'}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {selectedProduct && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-2 overflow-auto">
          <div className="bg-white rounded-2xl shadow-2xl w-full mx-4 sm:mx-auto max-w-xs sm:max-w-md md:max-w-lg lg:max-w-xl xl:max-w-2xl max-h-[85vh] overflow-y-auto overflow-hidden">
            {/* Header */}
            <div className={`flex items-center justify-between px-6 py-4 bg-gradient-to-r ${getCategoryGradient(selectedProduct.categoria)} text-white`}>
              <h3 className="text-2xl font-bold">{selectedProduct.titulo}</h3>
              <button onClick={closeModal} className="text-3xl leading-none hover:opacity-80">&times;</button>
            </div>
            {/* Body */}
              <div className="p-6">
                <p className="text-gray-700 text-base leading-relaxed mb-6">{selectedProduct.descripcion}</p>
                <div className="flex flex-col items-center md:flex-row md:justify-center md:space-x-8 mb-6">
                <img src={selectedProduct.imagen} alt={selectedProduct.titulo} className="w-32 h-32 md:w-48 md:h-48 object-contain rounded-md shadow-inner mb-4 md:mb-0" />
                {selectedProduct.titulo === 'Frijoles Bayos' && (
<div
  className="w-32 h-32 md:w-48 md:h-48 overflow-hidden rounded-md shadow-lg cursor-zoom-in"
  onMouseEnter={() => setZoomLevel(zoomScale)}
  onMouseMove={handleNutritionalMove}
  onMouseLeave={() => { resetNutritional(); setZoomLevel(1); }}
>
  <img
    src={bayosinfo}
    alt="Información nutricional Bayos"
    className="w-full h-full object-contain filter grayscale drop-shadow-lg transition-transform duration-300"
    style={{ transformOrigin: nutritionalOrigin, transform: `scale(${zoomLevel})` }}
  />
</div>
                )}
                {selectedProduct.titulo === 'Frijoles Negros' && (
<div
  className="w-32 h-32 md:w-48 md:h-48 overflow-hidden rounded-md shadow-lg cursor-zoom-in"
  onMouseEnter={() => setZoomLevel(zoomScale)}
  onMouseMove={handleNutritionalMove}
  onMouseLeave={() => { resetNutritional(); setZoomLevel(1); }}
>
  <img
    src={negrosinfo}
    alt="Información nutricional Negros"
    className="w-full h-full object-contain filter grayscale drop-shadow-lg transition-transform duration-300"
    style={{ transformOrigin: nutritionalOrigin, transform: `scale(${zoomLevel})` }}
  />
</div>
                )}
                {selectedProduct.titulo === 'Frijoles Peruanos' && (
<div
  className="w-32 h-32 md:w-48 md:h-48 overflow-hidden rounded-md shadow-lg cursor-zoom-in"
  onMouseEnter={() => setZoomLevel(zoomScale)}
  onMouseMove={handleNutritionalMove}
  onMouseLeave={() => { resetNutritional(); setZoomLevel(1); }}
>
  <img
    src={peruanosinfo}
    alt="Información nutricional Peruanos"
    className="w-full h-full object-contain filter grayscale drop-shadow-lg transition-transform duration-300"
    style={{ transformOrigin: nutritionalOrigin, transform: `scale(${zoomLevel})` }}
  />
</div>
                )}
              </div>
                <div className="space-y-4">
                <div>
                  <h4 className="font-semibold text-gray-900">Categoría:</h4>
                  <span className={`inline-block mt-1 px-3 py-1 rounded-full text-sm font-medium text-white ${getCategoryColor(selectedProduct.categoria)}`}>{selectedProduct.categoria}</span>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900">Características:</h4>
                  <div className="flex flex-wrap gap-2 mt-2">
                    <span className="px-2 py-1 bg-green-100 text-green-700 text-xs rounded-full">Certificado</span>
                    <span className="px-2 py-1 bg-blue-100 text-blue-700 text-xs rounded-full">FDA</span>
                  </div>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900">Detalles:</h4>
                  <ul className="list-disc list-inside text-gray-700 text-sm mt-2">
                    {selectedProduct.detalles.map((detalle, index) => (
                      <li key={index} className="flex items-center gap-2">
                        <Check className="w-4 h-4 text-green-600" />
                        {detalle}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PackagedPueblo;
